<template>

    <div v-if="right" style="float: right;" class="link" @click="$emit('click')" >
      <p><slot name='default' /></p>
      <v-icon class="icon">chevron_left</v-icon>
    </div>

    <div v-else class="link" @click="$emit('click')" >
      <v-icon class="icon">chevron_right</v-icon>
      <slot name='default' />
    </div>

</template>

<script>
export default {
  name: 'ActionLink',
  props: {
    right: Boolean,
    left: Boolean
  }
};
</script>
<!--Trigger-->

<style lang='scss' scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.link {
  display: flex;
  position: relative;
  top: 1px;
  font-weight: 500;

  &:hover {
    cursor: pointer;
    p {
      font-weight: 500;
      color: $primary;
    }

    .icon {
      background-color: $gray;
      color: $primary;
    }
  }

  transition: $base-transition;

  .icon {
    border-radius: $border-radius;
    background-color: $gray-lighten-2;
    color: $primary;
  }

  p {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
